import { Component, effect, HostListener, Inject, Input, OnChanges, OnDestroy, OnInit, signal, SimpleChanges, output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, NavigationEnd, RoutesRecognized, RouterLinkActive, RouterLink } from '@angular/router';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import { Subject } from 'rxjs';
import { combineLatest } from 'rxjs';
import {
  ContractGuard,
  ISelectedContract,
  LoggedInUserSettings,
  GlobalModalWindowService,
  PGHOktaService,
  SessionManagementService,
  PGHAppLoadService,
  StorageService,
  GSSPAuthenticationService,
  myAccountRouteWithSlash,
  myTechServicesRouteWithSlash,
  ServiceRequestVisibilityService,
} from 'src/app/core/core';
import { filter, map, take, takeUntil } from 'rxjs/operators';
import { IPlan } from 'src/app/model/portal-profile/IPortalProfile';
import { IImageProperties, ILogo } from 'src/app/model/sitefinity/IGlobalHeaders';
import {
  CLAIMSANDSUPPORTURL,
  CLAIMSSUPPORTURLNAME,
  LANGUAGES,
  PGIDPERKURLNAME,
  PROFILEURLNAME,
  PROGRAMINFORMATION,
  VIEWCLAIMSTATUS,
  TECHSERVICEURLNAME,
  COVERAGEURLNAME,
  VIEWTUTORIALS,
  REQUESTSERVICE,
} from '../../constants/feature-key.constants';
import { Location, NgClass, NgStyle, CommonModule } from '@angular/common';
import { ClaimsNoDevicesModalWindowComponent } from 'src/app/shared';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { ADPComponentsModule, ADPResourceService, SitefinityMenuItem } from 'digital-core';
import { OktaAuth } from '@okta/okta-auth-js';
import { GetStartedModalComponent } from 'src/app/shared';
import { SettingFalseDirective, GtmClickDirective, SettingTrueDirective, AriaLabelDirective } from 'src/app/shared';
import { ADPImageComponent } from '../../../shared';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from 'src/app/core/core';
import { AvatarComponent } from '../../../shared';
import { HeaderService } from 'src/app/core/services/header.service';
import { GTMEvents, GTMModalCategories } from '../../../model/google-tag-manager/api-status';
import { PGHIdentityService } from '../../services/pghidentity.service';
import { PGHIdentityAuthStateService } from '../../services/pghidentity-auth-state.service';
import { PlanRenewalService } from 'src/app/shared/components/plan-renewal-notice';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    SettingFalseDirective,
    GtmClickDirective,
    ADPImageComponent,
    SettingTrueDirective,
    AriaLabelDirective,
    NgClass,
    MatButton,
    MatIconButton,
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    RouterLinkActive,
    RouterLink,
    NgStyle,
    AvatarComponent,
    CommonModule,
    ADPComponentsModule,
  ],
  providers: [PlanRenewalService],
})
export class HeaderComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isSidenavShowing: boolean;
  readonly onMenuShow = output<boolean>();
  readonly onFixedHeader = output<boolean>();
  readonly OKTA_TOKEN_STORAGE = 'okta-token-storage';

  protected readonly GTMEvents = GTMEvents;
  protected readonly GTMModalCategories = GTMModalCategories;

  isOpen = false;
  isProfileMenuOpen = false;
  isClaimsMenuOpen = false;
  isCoverageMenuOpen = false;
  isProgramMenuOpen = false;
  isTechServicesInMenu = false;
  isCreateAccountOpen = false;
  areLinksLoaded: boolean = false;
  areClaimsLinksLoaded: boolean = false;
  areCoverageLinksLoaded: boolean = false;
  isAuthenticated: boolean = false;
  headerLoggedInSettings: SitefinityMenuItem[] = null;
  headerLoggedOutSettings: SitefinityMenuItem[] = null;
  tempHeaderSettings: SitefinityMenuItem[] = null;
  tempProfileLinks: SitefinityMenuItem[] = null;
  tempClaimLinks: SitefinityMenuItem[] = null;
  tempCoverageLinks: SitefinityMenuItem[] = null;
  tempProgramInfoLinks: SitefinityMenuItem[] = null;
  profileLinks: SitefinityMenuItem[];
  defaultProfileLinks: SitefinityMenuItem[];
  claimsLinks: SitefinityMenuItem[];
  defaultClaimsLinks: SitefinityMenuItem[];
  coverageLinks: SitefinityMenuItem[];
  defaultCoverageLinks: SitefinityMenuItem[];
  programInfoLinks: SitefinityMenuItem[];
  createAccountItem: SitefinityMenuItem = null;
  requestServiceItem = signal<SitefinityMenuItem>(null);
  isFixedHeaderEnabled = signal<boolean>(false);
  isHomePage = signal<boolean>(false);
  isShowGenericAvatar = false;
  logoutHeaderHasLanguage = false;
  userGivenName: string = '';
  userAvatarUrl: string = '';
  userAvatarColor: string = '';
  isExpired: boolean = false;
  isCancelled: boolean = false;
  cancelledOrExpiredHasFullAccess: boolean = false;
  isPTPO: boolean = false;
  hasActiveAccount: boolean = true;
  headerLogos: ILogo[];
  alesSiteDetails: IImageProperties;
  isExternalOrigin: boolean = false;
  isAIZHeader: boolean = false;
  isPGHEssentialHeader: boolean = false;
  isTechServicesEnabled: boolean = false;
  isGSSP = false;
  dealerCode: string;
  masterCertificateNumber: string;
  coverageTypeCode: string;
  redirectUrl: string;
  contractNum: string;
  zipCode: string;
  isActive: boolean;
  isMainNavVisible: boolean = true;
  allDevices: PghUserDeviceBase[];
  originQueryParam: any;
  childCertificateNumber: string;
  isSRLoaded = false;
  userFullName: string = '';
  isSessionServiceInvoked = false;
  languages: any;
  selectedLanguageKey: string = null;
  chooseLanguage: string = null;
  chooseLanguageTitle: string = null;
  isServiceRequestMode = false;
  isRenewPlanMode = false;
  globalHeaderLogoUrl: string;
  hasBothPlanTypes = false;
  hasMappOnly = false;

  private destroy$ = new Subject<boolean>();

  constructor(
    @Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
    private oktaAuthservice: OktaAuthStateService,
    private selectedDeviceService: SelectedDeviceService,
    private appLoadService: PGHAppLoadService,
    private userSettings: LoggedInUserSettings,
    private matDialog: MatDialog,
    private contractGuard: ContractGuard,
    private router: Router,
    private location: Location,
    private domSanitizer: DomSanitizer,
    private gsspAuthService: GSSPAuthenticationService,
    private pghOktaService: PGHOktaService,
    private pghIdentityService: PGHIdentityService,
    private identityAuthStateService: PGHIdentityAuthStateService,
    public resourceService: ADPResourceService,
    private sessionManagementService: SessionManagementService,
    private globalModalWindowService: GlobalModalWindowService,
    private storageService: StorageService,
    public headerService: HeaderService,
    public serviceRequestVisibility: ServiceRequestVisibilityService,
    private planRenewal: PlanRenewalService
  ) {
    this.planRenewal.setContext('Global');
    effect(() => {
      this.onFixedHeader.emit(this.isFixedHeaderEnabled());
    });
  }

  async ngOnInit(): Promise<void> {
    this.appLoadService.isSiteResourcesLoaded.subscribe((value) => {
      this.isSRLoaded = value;
      if (value) {
        this.getLanguages();
        this.setAppHeaders();
        this.globalHeaderLogoUrl = this.resourceService.getPortalSetting('Global_Header_Logo_Url')?.Value ?? '/';
      }
    });
    this.isAuthenticated = this.pghOktaService.isTokenValid() || this.pghIdentityService.isTokenValid();

    // Detect dual plan type (MAPP + LPP) for /plan-coverage routing
    combineLatest([
      this.appLoadService.isSiteResourcesLoaded.pipe(filter((v) => !!v), take(1)),
      this.userSettings.$plans.pipe(filter((v): v is IPlan[] => v !== null)),
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ([_, plans]) => {
          const mappDealerCodes = (this.resourceService.getPortalSetting('Global_MAPP_Dealer_Codes')?.Value ?? '')
            .split(',')
            .map((c) => c.trim())
            .filter(Boolean);
          const hasMapp = plans.some((p) => mappDealerCodes.includes(p.dealerCode));
          const hasLpp = plans.some((p) => !mappDealerCodes.includes(p.dealerCode));
          this.hasBothPlanTypes = hasMapp && hasLpp;
          this.hasMappOnly = hasMapp && !hasLpp;
        },
        error: () => {
          /* hasBothPlanTypes stays false on error */
        },
      });

    let userClaims = null;

    // Seed service-request button visibility based on current route so it doesn't flash
    // on dashboard while the inline CTA is still loading. The dashboard's appServiceTracker
    // takes over once its tracked section renders; other routes keep the button visible.
    this.headerService.toggleServiceButtonVisible(!this.isLandingRoute(this.router.url));
    this.isHomePage.set(this.isHomeRoute(this.router.url));
    this.isRenewPlanMode = this.isPlanRenewalRoute(this.router.url);

    // RoutesRecognized fires after the router resolves redirects (e.g. '/' -> '/dashboard'
    // from /select-home submit) and before the new route's component is created — early
    // enough to prevent the flash that NavigationStart misses.
    this.router.events
      .pipe(
        filter((e): e is RoutesRecognized => e instanceof RoutesRecognized),
        takeUntil(this.destroy$)
      )
      .subscribe((e) => {
        this.headerService.toggleServiceButtonVisible(!this.isLandingRoute(e.urlAfterRedirects));
      });

    combineLatest([this.router.events.pipe(filter((route) => route instanceof NavigationEnd))])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([routerEvents]: [any]) => {
        // if phones onboarding or diagnostic routing, hide the main nav in header
        if (routerEvents.url.includes('/po') || routerEvents.url.includes('/pd') || routerEvents.url.includes('isOnboardingFlow')) {
          this.isMainNavVisible = false;
        } else {
          this.isMainNavVisible = true;
        }

        this.isCreateAccountOpen = routerEvents.url.includes('/create-account');
        this.isHomePage.set(this.isHomeRoute(routerEvents.url));
        this.isRenewPlanMode = this.isPlanRenewalRoute(routerEvents.url);
        this.handleActiveRoutes(routerEvents.url, routerEvents.urlAfterRedirects);
      });

    combineLatest([this.oktaAuthservice.authState$.pipe(map((state) => state?.isAuthenticated ?? false)), this.identityAuthStateService.authState$.pipe(map((state) => state.isAuthenticated))])
      .pipe(
        map(([okta, identity]) => okta || identity),
        takeUntil(this.destroy$)
      )
      .subscribe(async (isAuthenticated) => {
        this.isAuthenticated = isAuthenticated;
        if (this.isAuthenticated) {
          this.appLoadService.isSiteResourcesLoaded
            .pipe(
              filter((value) => !!value && !this.isSessionServiceInvoked),
              take(1),
              takeUntil(this.destroy$)
            )
            .subscribe(() => {
              this.sessionManagementService.configureSessionTimeOut();
              this.isSessionServiceInvoked = true;
            });
          userClaims = (await this.pghOktaService.getUser()) || this.pghIdentityService.getUser();
          if (!userClaims) {
            await this.clearSession();
          } else {
            this.userGivenName = userClaims.given_name;
            this.userFullName = userClaims.name;
            if (this.userGivenName) {
              this.userGivenName = this.userGivenName[0].toUpperCase() + this.userGivenName.substr(1).toLowerCase();
            }
          }
        } else {
          // await this.clearSession();
        }
      });

    if (this.isAuthenticated) {
      userClaims = (await this.pghOktaService.getUser()) || this.pghIdentityService.getUser();
      this.userGivenName = userClaims?.given_name;
      this.userFullName = userClaims?.name;
      if (this.userGivenName) {
        this.userGivenName = this.userGivenName[0].toUpperCase() + this.userGivenName.substr(1).toLowerCase();
      }
    }

    this.userSettings.$selectedContract.pipe(takeUntil(this.destroy$)).subscribe((contract) => {
      if (!userClaims) {
        return;
      }
      if (contract) {
        const isEprismOnly = this.storageService.getLocal<string>(`IsEprismOnly`);
        const loggedInMember = isEprismOnly == 'true' ? contract?.members[0] : contract?.members?.find((m) => m?.emailAddress?.toLowerCase() === userClaims?.email?.toLowerCase());
        this.isExpired = contract.isExpired;
        this.isCancelled = contract.isCancelled;
        this.isPTPO = contract.isPTPO;
        if (loggedInMember) {
          this.userAvatarUrl = loggedInMember.avatarUrl;
          this.userAvatarColor = loggedInMember.profileColor;
        }
      }
    });

    this.userSettings.$hasActiveAccount.pipe(takeUntil(this.destroy$)).subscribe((hasActiveAccount) => {
      this.hasActiveAccount = hasActiveAccount;
    });

    // listen for SR header mode
    this.headerService.serviceRequestMode$.pipe(takeUntil(this.destroy$)).subscribe((on) => (this.isServiceRequestMode = on));

    combineLatest([this.router.events.pipe(filter((e) => e instanceof NavigationEnd))])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([e]: [NavigationEnd]) => {
        const isSR = e.urlAfterRedirects?.includes('/service-request');
        if (isSR !== this.isServiceRequestMode) {
          this.headerService.toggleServiceRequestMode(!!isSR);
        }
        if (!this.isAuthenticated) {
          this.globalHeaderLogoUrl = '/';
        }
      });
  }

  private handleActiveRoutes(routeUrl, urlAfterRedirects) {
    const isSPOEEnabled = this.resourceService.isPortalSettingTrue('Global_SPOE_Enabled');
    if ((routeUrl.includes('/device-') || routeUrl.includes('/home-device')) && routeUrl != '/device-select') {
      //this.renderer.addClass(routerEvents.id, "active-route");
      //this.element(document.querySelector(routerEvents.id)).addClass('.active-route');
      const alink = document.getElementById('my-devices');
      if (alink != null) {
        setTimeout(() => {
          const alink = document.getElementById('my-devices');
          alink.classList.add('active');
        }, 10);
      }
      const supportlink = document.getElementById('claimsSupportMenu');
      if (supportlink != null) {
        supportlink.classList.remove('active-route');
      }
    } else if (routeUrl === '/device-select' || routeUrl === '/claims-support') {
      const alink = document.getElementById('claimsSupportMenu');
      if (alink != null && !isSPOEEnabled) {
        setTimeout(() => {
          const alink = document.getElementById('claimsSupportMenu');
          alink.classList.add('active');
        }, 500);
      }
      const devicelink = document.getElementById('my-devices');
      if (devicelink != null) {
        devicelink.classList.remove('active-route');
      }
    } else if (isSPOEEnabled && routeUrl === '/tech-services') {
      const alink = document.getElementById('claimsSupportMenu');
      if (alink != null) {
        setTimeout(() => {
          const alink = document.getElementById('claimsSupportMenu');
          alink.classList.add('active');
        }, 500);
      }
    } else if (routeUrl.startsWith('/plan-coverage')) {
      // Fire after routerLinkActive so we aren't overwritten by its NavigationEnd handler
      setTimeout(() => {
        // Dropdown button version (action_coverage CMS config — MAPP/dual-plan accounts)
        document.getElementById('coverageMenu')?.classList.add('active');
        // Regular <a> link version (direct URL CMS config — single-plan LPP/MAPP accounts)
        document.getElementById('plan-coverage')?.classList.add('active');
      }, 200);
    } else if (isSPOEEnabled && (routeUrl === '/coverage-home' || routeUrl === '/coverage-mobile')) {
      const alink = document.getElementById('coverageMenu');
      if (alink != null) {
        setTimeout(() => {
          const alink = document.getElementById('coverageMenu');
          alink.classList.add('active');
        }, 500);
      }
    } else {
      /* CLEANUP */
      const alink = document.getElementById('my-devices');
      if (alink != null) {
        alink.classList.remove('active-route');
      }
      const supportlink = document.getElementById('claimsSupportMenu');
      if (supportlink != null) {
        supportlink.classList.remove('active-route');
      }
    }

    var fixedHeaderEnabled = this.resourceService.isPortalSettingTrue('Header_Set_Fixed_Header_Enabled');
    this.isFixedHeaderEnabled.set(fixedHeaderEnabled);
  }

  private menuId(route) {
    const navId = route.replace('/', '');
    return navId;
  }

  private getLanguages() {
    let local = this.storageService.getLocal<string>(`language`);
    this.selectedLanguageKey = local ?? 'EN';
    let languages = this.resourceService.getListItemResource('Global_Languages');
    languages.subscribe((data) => {
      this.languages = data;
      const language = this.languages.find((x) => x.Key.toLocaleLowerCase() === this.getSelectedLanguage().toLocaleLowerCase());
      this.selectedLanguageKey = language?.Key;
      this.chooseLanguage = this.languages.find((x) => x.Key != this.selectedLanguageKey)?.Value;
      this.chooseLanguageTitle = this.resourceService.getViewLabel('Global_Language_Title') + this.chooseLanguage;
      if (!this.selectedLanguageKey) {
        this.storageService.setLocal(`language`, null);
        window.location.reload();
      }
    });
  }

  private setAppHeaders() {
    this.resourceService.getPortalMenus('Header_LoggedOut_Nav_Menu').subscribe((data) => {
      this.headerLoggedOutSettings = data.MenuItems;
      if (this.headerLoggedOutSettings?.length) {
        const programLinks = this.headerLoggedOutSettings.find((x) => x.LinkUrl === PROGRAMINFORMATION);
        if (programLinks) {
          this.resourceService.getPortalMenus('Header_Program_Information_Child_Menu').subscribe((childData) => {
            this.programInfoLinks = JSON.parse(JSON.stringify(childData.MenuItems));
          });
        }
        this.logoutHeaderHasLanguage = !!this.headerLoggedOutSettings.find((x) => x.LinkUrl == LANGUAGES);
      }
    });
    this.resourceService.getPortalMenus('Header_LoggedIn_Nav_Menu').subscribe((data) => {
      this.headerLoggedInSettings = data.MenuItems;
      if (!this.tempHeaderSettings) {
        this.tempHeaderSettings = JSON.parse(JSON.stringify(data.MenuItems));
      }
      if (this.headerLoggedInSettings?.length) {
        const profileLinks = this.headerLoggedInSettings.find((x) => x.LinkUrl === PROFILEURLNAME);
        if (profileLinks) {
          this.resourceService.getPortalMenus('Header_Profile_Child_Menu').subscribe((childData) => {
            this.defaultProfileLinks = childData.MenuItems;
            if (!this.tempProfileLinks) {
              this.tempProfileLinks = JSON.parse(JSON.stringify(childData.MenuItems));
            }
          });
        }
        const supportCenter = this.headerLoggedInSettings.find((x) => x.LinkUrl.endsWith(CLAIMSSUPPORTURLNAME));
        if (supportCenter) {
          this.resourceService.getPortalMenus('Header_Claims_Support_Child_Menu').subscribe((childData) => {
            this.defaultClaimsLinks = childData.MenuItems;
            if (!this.tempClaimLinks) {
              this.tempClaimLinks = JSON.parse(JSON.stringify(childData.MenuItems));
            }
          });
        }
        const techServicesMenu = this.headerLoggedInSettings.find((x) => x.LinkUrl.endsWith(TECHSERVICEURLNAME));
        if (techServicesMenu) {
          this.isTechServicesInMenu = true;
        }
        const requestService = this.headerLoggedInSettings.find((x) => x.LinkUrl.endsWith(REQUESTSERVICE));
        if (requestService) {
          this.requestServiceItem.set(requestService);
        }
      }
    });
    this.userSettings.$selectedContract.subscribe((contract) => {
      let hasP360MobilePolicy = this.storageService.getLocal<string>(`EprismContractsCount`) > '0';
      let hasP360HomeTechPolicy = this.storageService.getLocal<string>(`ElitaContractsCount`) > '0';
      if (this.tempHeaderSettings?.length) {
        this.headerLoggedInSettings = JSON.parse(JSON.stringify(this.tempHeaderSettings));
        if (!contract?.isPrimary) {
          this.headerLoggedInSettings = this.headerLoggedInSettings?.filter((x) => x.LinkUrl !== '/claims');
          this.headerLoggedInSettings = this.headerLoggedInSettings?.filter((x) => x.LinkUrl !== '/file-a-claim');
        }
      }
      if (this.headerLoggedInSettings) {
        const profileLinks = this.headerLoggedInSettings?.find((x) => x.LinkUrl === PROFILEURLNAME);
        if (profileLinks && this.tempProfileLinks?.length) {
          this.profileLinks =
            (hasP360MobilePolicy && !hasP360HomeTechPolicy) || !contract?.isPrimary
              ? this.tempProfileLinks.filter((x) => !x.LinkUrl.includes('communication-preferences') && !x.LinkUrl.includes('family-management'))
              : this.tempProfileLinks;
          /*this.profileLinks = (hasP360MobilePolicy && !hasP360HomeTechPolicy && !contract?.isPrimary) ?
                        this.profileLinks.filter(x => !x.LinkUrl.includes('details')) :
                        this.profileLinks;*/
          this.areLinksLoaded = true;
        }
        const supportCenter = this.headerLoggedInSettings.find((x) => x.LinkUrl.endsWith(CLAIMSSUPPORTURLNAME));
        if (supportCenter && this.tempClaimLinks?.length) {
          this.claimsLinks = this.tempClaimLinks;
          this.claimsLinks = hasP360MobilePolicy && !hasP360HomeTechPolicy ? this.claimsLinks.filter((x) => !x.LinkUrl.includes('/faq')) : this.claimsLinks;
          this.claimsLinks = !hasP360MobilePolicy && hasP360HomeTechPolicy ? this.claimsLinks.filter((x) => !x.LinkUrl.includes('/p360')) : this.claimsLinks;
          this.areClaimsLinksLoaded = true;
        }

        const coverageLinks = this.headerLoggedInSettings.find((x) => x.LinkUrl.endsWith(COVERAGEURLNAME));
        if (coverageLinks && contract) {
          this.resourceService.getPortalMenus('Header_Coverage_Child_Menu').subscribe((childData) => {
            let filteredChildMenuItems = childData.MenuItems;

            if (hasP360MobilePolicy && hasP360HomeTechPolicy) {
              // Multipe policy both P360 Mobile & Home tech
              filteredChildMenuItems = childData.MenuItems;
            } else if (hasP360HomeTechPolicy) {
              filteredChildMenuItems = childData.MenuItems.filter((x) => x.LinkUrl.endsWith('home'));
            } else if (hasP360MobilePolicy) {
              filteredChildMenuItems = childData.MenuItems.filter((x) => x.LinkUrl.endsWith('mobile'));
            }

            this.defaultCoverageLinks = filteredChildMenuItems;

            if (!this.tempCoverageLinks) {
              this.tempCoverageLinks = JSON.parse(JSON.stringify(filteredChildMenuItems));
            }
            if (this.tempCoverageLinks?.length) {
              this.coverageLinks = this.tempCoverageLinks;
              this.areCoverageLinksLoaded = true;
            }
          });
        }
      }
    });
    this.resourceService.getPortalMenus('Header_CreateAccount_Nav_Menu').subscribe((data) => {
      this.createAccountItem = data.MenuItems.length > 0 ? data.MenuItems[0] : null;
    });
    this.isShowGenericAvatar = this.resourceService.getPortalSetting('Global_Avatar_Show_Generic_Avatar_Enabled')?.Value === 'true';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isSidenavShowing) {
      this.isOpen = this.isSidenavShowing;
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  onToggleMenu(): void {
    this.isOpen = !this.isOpen;
    this.onMenuShow.emit(this.isOpen);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    // when large breakpoint is hit and sidenav is showing
    if (event.target.innerWidth >= 992 && this.isSidenavShowing) {
      // hide sidenav
      this.onToggleMenu();
    }
  }

  checkRouteAvailability(route: string) {
    const cancelledOrExpiredHasFullAccess = this.resourceService.isPortalSettingTrue('Global_CancelledOrExpiredContract_HasFullAccess');
    if ((this.isCancelled || this.isExpired) && !cancelledOrExpiredHasFullAccess && route === myAccountRouteWithSlash) {
      return false;
    } else if ((((this.isCancelled || this.isExpired) && !cancelledOrExpiredHasFullAccess) || this.isPTPO) && route === myTechServicesRouteWithSlash) {
      return false;
    } else {
      return true;
    }
  }

  profileButtonClick(navigationItem: SitefinityMenuItem) {
    let url = navigationItem.LinkUrl;
    if (navigationItem?.LinkUrl?.startsWith('/')) {
      this.router.navigate([url]);
    } else if (url.startsWith('http') || navigationItem?.LinkUrl?.endsWith(PGIDPERKURLNAME)) {
      window.open(url, '_blank');
    }
  }

  openTutorial(label: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.ariaLabel = label;
    dialogConfig.id = 'get-started-dialog';
    dialogConfig.height = 'auto';
    dialogConfig.data = {
      title: 'Account',
      content: '',
      buttonText: 'Next',
    };

    this.matDialog.open(GetStartedModalComponent, dialogConfig);
  }

  claimsButtonClick(navigationItem: SitefinityMenuItem) {
    if (navigationItem?.LinkUrl == VIEWCLAIMSTATUS) {
      this.viewClaimHistoryAndStatus();
      return;
    }

    if (navigationItem?.LinkUrl == VIEWTUTORIALS) {
      this.openTutorial(this.resourceService.getLabel('Perks_Tutorial_Button_Button'));
      return;
    }

    //special behavior for claims & support navigation link to only allow navigation to Claims & Support page if user
    //has devices in their inventory
    if (navigationItem?.LinkUrl == CLAIMSANDSUPPORTURL) {
      if (this.resourceService.getViewLabel('Global_Modal_NoDevices_Title')) {
        this.allDevices = this.selectedDeviceService.getAllDevices();
        if (this.allDevices?.length > 0) {
          this.router.navigate([navigationItem?.LinkUrl]);
        }
        //display a modal notification to user that they have no devices in their inventory with an option to navigate to My Devices page
        else {
          this.displayClaimsNoDevicesModal();
        }
      } else {
        this.router.navigate([navigationItem?.LinkUrl]);
      }
    } else {
      if (navigationItem?.LinkUrl.startsWith('http')) {
        window.open(navigationItem?.LinkUrl, '_blank');
      } else {
        this.router.navigate([navigationItem?.LinkUrl]);
      }
    }
  }

  displayClaimsNoDevicesModal(msg: string = '') {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.ariaLabel = this.resourceService.getPortalLabel('Global_Modal_NoDevices_Title').Value;
    dialogConfig.disableClose = false;
    dialogConfig.id = 'claims-no-devices-dialog';
    dialogConfig.height = 'auto';
    dialogConfig.data = {
      subtitle: 'Global_Modal_NoDevices_Subtitle',
      title: 'Global_Modal_NoDevices_Title',
      description: 'Global_Modal_NoDevices_Description',
      buttonText: 'Global_Modal_NoDevices_ButtonText',
    };

    const dialogRef = this.matDialog.open(ClaimsNoDevicesModalWindowComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((res) => {
      if (res.data && res.data.result === 'success') {
        this.router.navigate([this.resourceService.getPortalSetting('URL_MyDevices').Value]);
      }
    });
  }

  coverageButtonClick(navigationItem: SitefinityMenuItem) {
    if (this.hasBothPlanTypes) {
      this.router.navigate(['/plan-coverage']);
      return;
    }
    if (this.hasMappOnly) {
      this.router.navigate(['/plan-coverage-mapp']);
      return;
    }
    let url = navigationItem.LinkUrl;
    if (navigationItem?.LinkUrl?.startsWith('/')) {
      this.router.navigate([url]);
    }
  }

  viewClaimHistoryAndStatus() {
    const searchClaimsUrl = this.resourceService.getPortalSetting('URL_ClaimsPortal').Value;

    const joined$ = combineLatest([this.userSettings.$selectedContract]).pipe(
      filter(([a]) => a !== null),
      takeUntil(this.destroy$)
    );

    joined$.subscribe(([selectedContract]: [ISelectedContract]) => {
      this.isActive = this.contractGuard.activateGuard(selectedContract, false);
      this.isGSSP = selectedContract.useGSSPClaims;
      this.masterCertificateNumber = selectedContract?.id;
      this.childCertificateNumber = selectedContract?.certificateNumberForGadgetsPolicy;
      this.dealerCode = selectedContract.dealerId;
      this.coverageTypeCode = 'AD';
      this.zipCode = selectedContract?.zipCode;
      this.contractNum = selectedContract && selectedContract?.members && selectedContract?.members.length ? selectedContract?.members[0].contractNumber : '';
    });

    if (this.isGSSP) {
      if (this.masterCertificateNumber && this.masterCertificateNumber.length > 0) {
        const childCertificateNumbers: [string] = [this.childCertificateNumber];
        this.gsspAuthService.postGenerateGSSPToken(this.dealerCode, this.masterCertificateNumber, childCertificateNumbers, null).subscribe({
          next: (gsspAuthToken: any) => {
            if (gsspAuthToken && gsspAuthToken.length > 0) {
              this.redirectUrl = `${searchClaimsUrl}?accessToken=${gsspAuthToken}`;
              this.redirectUrl = this.gsspAuthService.appendPathParam(this.redirectUrl);
              this.redirectUrl = this.domSanitizer.sanitize(SecurityContext.URL, this.redirectUrl);
              window.open(this.redirectUrl, '_self');
            } else {
              this.globalModalWindowService.showModalWindowMin('Global_Modal_Error_InvalidGsspAuthToken_Title', 'GetGsspAuthToken');
            }
          },
        });
      } else {
        this.globalModalWindowService.showModalWindowMin('Global_Modal_Error_MissingMasterCertificate_Title', 'GetGsspAuthToken');
      }
    } else {
      const tokens = JSON.parse(localStorage.getItem(this.OKTA_TOKEN_STORAGE));
      const accessToken = tokens.access_token && tokens.access_token.accessToken ? tokens.access_token.accessToken : tokens?.accessToken?.accessToken;
      const hashedQuery = btoa(`cn=${this.contractNum}&zip=${this.zipCode}`);
      if (accessToken.indexOf(' ') >= 0) {
        console.log('invalid token');
      } else {
        this.redirectUrl = `${searchClaimsUrl}?q=${hashedQuery}&token=${accessToken}`;
        this.redirectUrl = this.gsspAuthService.appendPathParam(this.redirectUrl);
        this.redirectUrl = this.domSanitizer.sanitize(SecurityContext.URL, this.redirectUrl);
        window.open(this.redirectUrl, '_blank');
      }
    }
  }

  routeToLogin(item) {
    this.location.replaceState(item.LinkUrl);
    this.router.navigate([item.LinkUrl]).then(() => {
      window.location.reload();
    });
  }

  getSelectedLanguage() {
    return this.selectedLanguageKey || 'EN';
  }

  toggleLanguage() {
    const language = this.languages.find((x) => x.Key.toLocaleLowerCase() != this.getSelectedLanguage().toLocaleLowerCase());
    this.storageService.setLocal<string>(`language`, language?.Key);
    window.location.reload();
  }

  private async clearSession() {
    this.oktaAuth.tokenManager.clear();
    await this.oktaAuth.closeSession();
    await this.oktaAuth.revokeAccessToken();
  }

  onExitServiceRequest() {
    this.router.navigate(['/dashboard']);
  }

  onExitRenewPlan(): void {
    this.router.navigate(['/dashboard']);
  }

  private isHomeRoute(url: string | undefined | null): boolean {
    if (!url) return false;
    const path = url.split('?')[0].split('#')[0];
    return path === '/home' || path.startsWith('/home/') || path === '/lookup-account' || path.startsWith('/lookup-account/');
  }

  private isLandingRoute(url: string | undefined | null): boolean {
    if (!url) {
      return false;
    }
    const path = url.split('?')[0].split('#')[0];
    return path === '/dashboard' || path.startsWith('/dashboard/') || path === '/select-home' || path.startsWith('/select-home/') || path === '/home' || path.startsWith('/home/');
  }

  private isPlanRenewalRoute(url: string | undefined | null): boolean {
    if (!url) {
      return false;
    }
    const path = url.split('?')[0].split('#')[0];
    return path === '/renew' || path.startsWith('/renew/');
  }

  onClickServiceRequest(): void {
    if (this.resourceService.getPortalSetting('Global_Restrict_GSSP_Handover').Value === 'true') {
      this.gsspAuthService.openServiceRequestModal();
    } else if (this.planRenewal.isGSSPModalVisible()) {
      // Warn expired users that coverage only applies to issues from before it ended
      // before sending them into the service-request flow.
      this.gsspAuthService
        .openCoverageEndedServiceModal()
        .afterClosed()
        .subscribe((shouldContinue) => {
          if (shouldContinue) {
            this.router.navigate(['/service-request']);
          }
        });
    } else {
      this.router.navigate(['/service-request']);
    }
  }

  getResourceViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }
}
